import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(admin)/polls/polls-page.tsx")